// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
            <path
                fill="currentColor"
                d="M1.875.625h-1.5A.375.375 0 0 0 0 1v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 2.25 2.5V1a.375.375 0 0 0-.375-.375Zm0 3.75h-1.5A.375.375 0 0 0 0 4.75v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Zm0 3.75h-1.5A.375.375 0 0 0 0 8.5V10c0 .207.168.375.375.375h1.5A.375.375 0 0 0 2.25 10V8.5a.375.375 0 0 0-.375-.375ZM4.5 2.5h6.75c.414 0 .75-.336.75-.729 0-.393-.335-.771-.75-.771H4.5a.745.745 0 0 0-.75.729c0 .393.335.771.75.771Zm6.75 6H4.5a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5Zm0-3.75H4.5a.75.75 0 1 0 0 1.5h6.75a.75.75 0 0 0 0-1.5Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(List);
